module.exports = "<svg viewBox=\"-10 -10 20 20\">\n <g stroke=\"currentColor\" fill=\"none\" stroke-width=\"3\" transform=\"rotate(-45)\"> \n   <path d=\"M 0 -8.5 A 8.5 8.5 0 0 1 8.5 0\" stroke-opacity=\"1\"/>\n   <path d=\"M 0 -8.5 A 8.5 8.5 0 1 0 8.5 0\" stroke-opacity=\"0.5\" />\n </g>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./packages/lui-spinner/theme/lui-spinner.html
// module id = 321
// module chunks = 0 1 26